import { createRef, useRef, useState } from "react";
import { isValidPhoneNumber, format } from "libphonenumber-js";

import { Box } from "@twilio-paste/core/box";
import { Button } from "@twilio-paste/core/button";
import { Card } from "@twilio-paste/core/card";

import { Paragraph } from "@twilio-paste/core/paragraph";

import { copy, types } from "./definitions";
import CompositeInputPhoneNumber from "../compositeInputPhoneNumber";
import { styled } from "@twilio-paste/core/styling-library";

// Custom height based on a balance between other componets around this one
// this max-height could be customized from props if needed on the future
const CardContainer = styled(Box)`
  div[data-paste-element="MENU_COUNTRIES_PHONE"] {
    max-height: 22rem;
    overflow: scroll;
  }
`;

const CardRequestPhoneNumber = ({
  description,
  label = copy.label,
  placeholder,
  menuPlacement,
  loading = false,
  onCancel,
  onSubmit,
}: types.CardRequestPhoneNumberProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const countryRef = createRef<HTMLInputElement>();
  const [error, setError] = useState<string | undefined>();

  const handleSubmit = async (): Promise<void> => {
    const phone = inputRef.current?.value;
    const country = countryRef.current?.value;

    if (phone && country) {
      const fullNumber = `+${country}${phone}`;
      const valid = isValidPhoneNumber(fullNumber);

      if (!valid) {
        setError(copy.errors.invalidPhone);
        return;
      }

      const parsedPhone = format(fullNumber, "INTERNATIONAL");

      await onSubmit(parsedPhone);
      return;
    }

    setError(copy.errors.invalidPhone);
  };

  return (
    <CardContainer>
      <Card padding={"space70"} element="CARD_PHONE_NUMBER">
        <Paragraph>{description}</Paragraph>

        <CompositeInputPhoneNumber
          id="request-phone-number"
          ref={inputRef}
          countryRef={countryRef}
          label={label}
          placeholder={placeholder}
          placement={menuPlacement}
          error={error}
          onChange={() => setError(undefined)}
          onEnter={handleSubmit}
        />

        <Box
          display="flex"
          justifyContent="space-between"
          paddingTop={"space70"}
        >
          <Button onClick={onCancel} variant="secondary">
            {copy.actions.cancel}
          </Button>
          <Button onClick={handleSubmit} variant="primary" loading={loading}>
            {copy.actions.submit}
          </Button>
        </Box>
      </Card>
    </CardContainer>
  );
};

export default CardRequestPhoneNumber;
